<template>
  <div id="app" :class="{ 'has-user-mobile-nav': showUserMobileNav }">
    <router-view/>
    <apoc-record-bar v-if="showUserFooter" />
    <user-mobile-nav v-if="showUserMobileNav" />
  </div>
</template>

<script>
import { ensureSiteConfig } from '@/store/site-config'
import ApocRecordBar from '@/components/ApocRecordBar.vue'
import UserMobileNav from '@/components/UserMobileNav.vue'

export default {
  name: 'AppRoot',
  components: { ApocRecordBar, UserMobileNav },
  created () {
    ensureSiteConfig()
  },
  computed: {
    showUserFooter () {
      return !this.$route.matched.some(r => r.meta && r.meta.admin)
    },
    showUserMobileNav () {
      const isAdmin = this.$route.matched.some(r => r.meta && r.meta.admin)
      return !isAdmin && this.$route.path !== '/login'
    }
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  font-family: var(--dz-font-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--dz-text);
  background: var(--dz-bg);
}
</style>
